var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Justified"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeJustified) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-tabs', {
    attrs: {
      "justified": "",
      "pills": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Home",
      "active": ""
    }
  }, [_c('b-card-text', [_vm._v(" Pastry gummi bears sweet roll candy canes topping ice cream. Candy canes fruitcake cookie carrot cake pastry. Lollipop caramels sesame snaps pie tootsie roll macaroon dessert. Muffin jujubes brownie dragée ice cream cheesecake icing. Danish brownie pastry cotton candy donut. Cheesecake donut candy canes. Jelly beans croissant bonbon cookie toffee. Soufflé croissant lemon drops tootsie roll toffee tiramisu. ")])], 1), _c('b-tab', {
    attrs: {
      "title": "Profile"
    }
  }, [_c('b-card-text', [_vm._v(" Pudding candy canes sugar plum cookie chocolate cake powder croissant. Carrot cake tiramisu danish candy cake muffin croissant tart dessert. Tiramisu caramels candy canes chocolate cake sweet roll liquorice icing cupcake.Bear claw chocolate chocolate cake jelly-o pudding lemon drops sweet roll sweet candy. Chocolate sweet chocolate bar candy chocolate bar chupa chups gummi bears lemon drops. ")])], 1), _c('b-tab', {
    attrs: {
      "title": "Disabled",
      "disabled": ""
    }
  }, [_c('b-card-text', [_vm._v(" Tootsie roll oat cake. ")])], 1), _c('b-tab', {
    attrs: {
      "title": "About"
    }
  }, [_c('b-card-text', [_vm._v(" Carrot cake dragée chocolate. Lemon drops ice cream wafer gummies dragée. Chocolate bar liquorice cheesecake cookie chupa chups marshmallow oat cake biscuit. Dessert toffee fruitcake ice cream powder tootsie roll cake.Chocolate bonbon chocolate chocolate cake halvah tootsie roll marshmallow. Brownie chocolate toffee toffee jelly beans bonbon sesame snaps sugar plum candy canes. ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }